import React, { useContext } from 'react'
import Navigation from '@App/navigation'
import { ICONS } from '@Const/common'
import { StoresContext } from '@App/contexts'
import ExpandableItem from '../../Sidebar/ExpandableItem'

const SummarySubNavigation = () => {
    const { rightsholderStore } = useContext(StoresContext)
    return (
        <ExpandableItem
            heading="Summary"
            icon={ICONS.summary}
            link={Navigation.rightholder.summary(rightsholderStore.currentRightsholderId)}
        />
    )
}

export default SummarySubNavigation
